import { showGrid } from './gridButton.actions';
import { showEpg } from './epgButton.actions';
import { showLiveOptionsMenu } from './liveOptionsButton.actions';
import { showLanguageOptions } from './languageOptions.actions';
import { showMenuSeries } from 'containers/Player/actions/series';

const buttonOptionClick = (option, showChevron) => dispatch => {
  const types = {
    grid: showGrid,
    epg: showEpg,
    options: showLiveOptionsMenu,
    language: showLanguageOptions,
    seasons: showMenuSeries,
  };
  dispatch(types[option](showChevron));
};

export default buttonOptionClick;
